import type { PrimeVueConfiguration } from "primevue/config";
import PrimeVue, { defaultOptions, usePrimeVue } from "primevue/config";
import Toast from "primevue/toast";
import { createApp } from "vue";

import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import ToastService from "primevue/toastservice";

import StyleClass from "primevue/styleclass";
import Tooltip from "primevue/tooltip";
import App from "./App.vue";
import { getTheme } from "./helpers/theme";
import { showToast } from "./helpers/toast";
import "./styles/tailwind.css";
import { initPasswordVisibility } from "./helpers/passwordVisibility";
import PasswordStrength from "./components/PasswordStrength.vue";

document.addEventListener("DOMContentLoaded", function () {
  const app = createApp(App);

  app.use(ToastService);
  app.use(ConfirmationService);
  app.use(DialogService);

  app.use(PrimeVue, {
    theme: {
      preset: getTheme(),
    },
    locale: {
      ...defaultOptions.locale,
      firstDayOfWeek: 1,
    },
    ripple: true,
    pt: {
      global: {
        css: `
              .p-card {
                border-radius: 10px;
              }
            `,
      },
      card: {
        root: {
          class: "shadow-card",
        },
      },
      button: {
        label: {
          class: "font-bold",
        },
      },
      tag: {
        root: {
          style: "min-width: 85px",
        },
      },
      paginator: {
        root: {
          class: "pt-6",
        },
      },
      dialog: {
        title: {
          class: "text-xl font-bold",
        },
      },
      pcRejectButton: {
        root: {
          id: "btnRejectModal",
          class: "p-button-outlined p-button-rounded p-button-lg",
        },
        label: {
          class: "font-bold text-base",
        },
      },
      pcAcceptButton: {
        root: {
          id: "btnAcceptModal",
          class: "p-button-rounded p-button-lg",
        },
        label: {
          class: "font-bold text-base",
        },
      },
      pcCloseButton: {
        root: {
          id: "btnCloseModal",
        },
      },
    },
  } as PrimeVueConfiguration);

  app.directive("styleclass", StyleClass);
  app.directive("tooltip", Tooltip);
  app.component("Toast", Toast);

  console.dir(document.getElementById("app"));
  app.mount("#app");

  app.runWithContext(async () => {
    showToast();
    initPasswordVisibility();
  });

  if (document.getElementById("password-new-strength")) {
    const app = createApp(PasswordStrength);
    app.mount("#password-new-strength");
  }
});
